import { ISmartFieldChange } from "@components/smart/smartField/SmartField";
import { createPath } from "@odata/BindingContext";
import { IPrEmploymentEntity, PrEmploymentCloseEntity, PrEmploymentEntity } from "@odata/GeneratedEntityTypes";
import { YesNoCode } from "@odata/GeneratedEnums";
import { ProvidePath, WITHOUT_CLAIM } from "@pages/payroll/employment/TerminateEmployment.def";
import { isObjectEmpty } from "@utils/general";
import { cloneDeep } from "lodash";

import {
    WithPermissionContext,
    withPermissionContext
} from "../../../contexts/permissionContext/withPermissionContext";
import { DATE_MAX, getUtcDayjs } from "../../../types/Date";
import DialogFormView, { IDialogFormViewProps } from "../../../views/formView/DialogFormView";
import { IFormStorageDefaultCustomData } from "../../../views/formView/FormStorage";

export interface ITerminateEmploymentCustomData extends IFormStorageDefaultCustomData {
}

interface IProps extends IDialogFormViewProps<IPrEmploymentEntity, ITerminateEmploymentCustomData>, WithPermissionContext {
}

class TerminateEmploymentFormView extends DialogFormView<IPrEmploymentEntity, IProps> {
    onAfterLoad(): Promise<void> {
        const storage = this.props.storage;
        // DATE_MAX is usually used on employment, but doesn't make sense here, so we clear it and force user to select a date
        if (getUtcDayjs(DATE_MAX).isSame(this.entity.DateEnd, "day")) {
            storage.clearValueByPath(PrEmploymentEntity.DateEnd);
        }

        const isDataProvided = !storage.getValueByPath(createPath(PrEmploymentEntity.EmploymentClose, PrEmploymentCloseEntity.NoUnemploymentSupportType));
        storage.setValueByPath(ProvidePath, isDataProvided);

        const salaryCompTypePath = createPath(PrEmploymentEntity.EmploymentClose, PrEmploymentCloseEntity.PrSalaryComponentType);
        if (isDataProvided && !storage.getValueByPath(salaryCompTypePath)) {
            storage.setValueByPath(salaryCompTypePath, WITHOUT_CLAIM);
        }

        return super.onAfterLoad();
    }


    handleChange(e: ISmartFieldChange): void {
        super.handleChange(e);
        if (e.bindingContext.getPath(true) === PrEmploymentCloseEntity.IsEndByDeath ||
            e.bindingContext.getPath(true) === ProvidePath) {
            // these two fields affect almost everything in the form, so I dont want to keep everything in affected fields
            this.props.storage.refresh();
        }
    }


    onBeforeSave(): IPrEmploymentEntity {
        const storage = this.props.storage;
        const entity = cloneDeep(this.entity);

        const hasTerminationBenefitBc = storage.data.bindingContext.navigate(createPath(PrEmploymentEntity.EmploymentClose, PrEmploymentCloseEntity.HasTerminationBenefitEntitled));
        const hasBenefit = !isObjectEmpty(entity.EmploymentClose?.PrSalaryComponentType);
        storage.setValue(hasTerminationBenefitBc, hasBenefit ? YesNoCode.Yes : YesNoCode.No);

        if (entity.EmploymentClose?.PrSalaryComponentTypeCode as string === WITHOUT_CLAIM) {
            entity.EmploymentClose.PrSalaryComponentTypeCode = null;
        }

        return entity;
    }
}

export default withPermissionContext(TerminateEmploymentFormView);
